import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { TITLE_TICKET, TICKET_REVIEW } from '../../../constants/texts';
import { useTicketConfirmationStyles } from './styles';

const TicketConfirmationText = ({ ...props }) => {
  const { request, ticketId } = props;
  const classes = useTicketConfirmationStyles();

  const { message } = useSelector((state) => state.ticketsReducer);
  const messageTicketInfo =
    message.length > 0 ? message : TICKET_REVIEW(request);

  return (
    <React.Fragment>
      <Typography className={classes.title}>{TITLE_TICKET(request)}</Typography>
      <Typography className={classes.subtitle}>
        Tu número de solicitud es:
      </Typography>
      <Typography className={classes.purpleDetail}>{ticketId}</Typography>
      <Typography className={classes.bodyText}>{messageTicketInfo}</Typography>
    </React.Fragment>
  );
};

TicketConfirmationText.propTypes = {
  request: PropTypes.bool,
  ticketId: PropTypes.any,
};

export default TicketConfirmationText;
